import { CopilotWidget } from '@asurion-core/copilot-widget';
import { copyMacroTextAction } from 'actions';
import { addEdgeToDecisionTreePath, returnToPreviousMacroWizardPath } from 'actions/searchActions';
import { ActionsButtonsWrapper, BackButton, NextButton } from 'components/common/buttonsComponents';
import { INBOUND, OUTBOUND } from 'constants/messageDirection';
import environment from 'environment';
import {
  extractSelectedTicketFromState,
  getChildrenOfCurrentDecisionNode,
  getDecisionNodeAtPath,
  getConversationMoreTicketInfo,
  isSelectedTicketReviewTicket,
} from 'extractFromState';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMessagesInConversation } from 'util/messageUtil';

const env = environment.nodeEnv === 'production' ? 'prod' : 'dev';

const serverUrl = new URL(environment.app.serverApiUrl);
const chatServerURL = serverUrl.protocol + '//' + serverUrl.hostname;

export const DTMLCopilotNode = () => {
  const dispatch = useDispatch();

  const decisionNode = useSelector(getDecisionNodeAtPath);
  const decisionNodeChildren = useSelector(getChildrenOfCurrentDecisionNode);
  const moreTicketInfo = useSelector(getConversationMoreTicketInfo);
  const nextButton = Object.keys(decisionNodeChildren || {})[0];
  const conversation = useSelector((state) =>
    getMessagesInConversation(
      extractSelectedTicketFromState(state),
      state.conversation,
      state.user,
      isSelectedTicketReviewTicket(state)
    )
  );

  const selectedTicket = useSelector(extractSelectedTicketFromState);
  const externalTicketId = selectedTicket?.ticketId;

  const handleClickCopyButton = (text) => {
    dispatch(copyMacroTextAction(text));
  };

  const transcript = useMemo(
    () =>
      conversation
        .filter(
          ({ direction, messageBody }) =>
            [OUTBOUND, INBOUND].includes(direction) &&
            messageBody !== 'User starting new ticket' &&
            messageBody !== 'escalating'
        )
        .map((message) => ({
          text: message.messageBody,
          sender: message.direction === INBOUND ? 'USER' : 'AGENT',
          id: message.messageId,
          timestamp: new Date(message.createdAt).getTime(),
        })),
    [conversation]
  );

  const widgetId = decisionNode?.widgetId || 'copilot';

  return (
    <div style={{ height: '100%' }}>
      <CopilotWidget
        externalTicketId={externalTicketId}
        customFlowSystemId=""
        transcript={transcript}
        widgetId={widgetId}
        moreTicketInfo={moreTicketInfo}
        salesforceService={{
          salesforceBackendUrl: chatServerURL,
        }}
        asurionChatService={{
          asurionChatServerUrl: chatServerURL,
        }}
        currentEnv={env}
        publicUrl={chatServerURL}
        publicServerDomain={chatServerURL}
        publicServerUrlPrefix="/chat-api"
        mixpanelToken={environment.copilot.mixpanelToken}
        startWidgetExpanded
        sentry={{ enabled: false }}
        fullStory={{ isDevMode: true }}
        showStateDebugger // needed for inputs
        copyMacro={handleClickCopyButton}
      />

      <ActionsButtonsWrapper style={{ position: 'absolute', bottom: 0, right: '5px', gap: '5px' }}>
        {!!nextButton && (
          <NextButton active={true} disabled={false} onClick={() => dispatch(addEdgeToDecisionTreePath(nextButton))}>
            {nextButton.toUpperCase()}
          </NextButton>
        )}
        <BackButton onClick={() => dispatch(returnToPreviousMacroWizardPath())}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </div>
  );
};
